import { render, staticRenderFns } from "./SuppliersPay.vue?vue&type=template&id=70071558"
import script from "./SuppliersPay.vue?vue&type=script&lang=js"
export * from "./SuppliersPay.vue?vue&type=script&lang=js"
import style0 from "./SuppliersPay.vue?vue&type=style&index=0&id=70071558&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports